import React from 'react';
import AltContainer from 'alt-container';
import connectToStores from 'alt-utils/lib/connectToStores';

import SavedSearchActionButtons from 'components/pure/search/SavedSearchActionButtons';
import SavedSearchWidget from 'components/pure/search/SavedSearchWidget';
import SavedSearchStore from 'stores/search/SavedSearchStore';
import SearchStore from 'stores/SearchStore';
import SavedSearchActions from 'actions/search/SavedSearchActions';

/**
 * SavedSearchWidgetContainer is a AltContainer component that wraps around a
 * SavedSearchWidget component which includes all the SavedSearch objects returned
 * from the backend.
 */
class SavedSearchWidgetContainer extends React.Component {
  static getStores() {
    return [SavedSearchStore];
  }

  static getPropsFromStores() {
    const savedSearchState = SavedSearchStore.getState();
    const searchState = SearchStore.getState();
    return {
      activeSearches: savedSearchState.get('activeSearches'),
      userIsSearchingSth: searchState.get('userIsSearchingSth'),
      openActionPopover: savedSearchState.get('openActionPopover'),
      searches: savedSearchState.get('searches'),
      searchesLoading: savedSearchState.get('searchesLoading'),
    };
  }

  constructor(props) {
    super(props);
    this.onTouchTapSaveSearchButton = this.onTouchTapSaveSearchButton.bind(this);
  }

  componentDidMount() {
    setImmediate(() => SavedSearchStore.fetch());
  }

  /**
   * Trigger a saved search action so that the SavedSearchStore can send
   * a request to the backend in order to persist the current search
   */
  onTouchTapSaveSearchButton(title) {
    setImmediate(() => {
      SavedSearchActions.persistCurrentSearch(title);
    });
  }

  /**
   * Return a JSX component that renders only the SavedSearchWidget since
   * the user is not "in" a search
   * @return {JSX} An <AltContainer /> component
   */
  renderWidgetInNonSearchMode() {
    return (
      <AltContainer
        actions={{
          SavedSearchActions: SavedSearchActions,
        }}>
        <SavedSearchWidget searches={this.props.searches} isInSearchMode={false} />
      </AltContainer>
    );
  }

  /**
   * Return a JSX component that renders <SavedSearchActionButtons/> on top
   * of <SavedSearchWidget/> since the user is "in" a search
   * @return {JSX} An <AltContainer /> component
   */
  renderWidgetInSearchMode() {
    return (
      <AltContainer
        actions={{
          SavedSearchActions: SavedSearchActions,
        }}>
        <SavedSearchActionButtons
          onTouchTapSaveSearchButton={this.onTouchTapSaveSearchButton}
          openPopover={this.props.openActionPopover}
        />
        <SavedSearchWidget searches={this.props.activeSearches} isInSearchMode={true} />
      </AltContainer>
    );
  }

  render() {
    if (this.props.searchTerm || this.props.userIsSearchingSth) {
      return this.renderWidgetInSearchMode();
    } else {
      return this.renderWidgetInNonSearchMode();
    }
  }
}

export default connectToStores(SavedSearchWidgetContainer);
